
export const auth = {
  AUTH_LOGIN_SUCCESS: "AUTH_LOGIN_SUCCESS",
  AUTH_LOGIN_ERROR: "AUTH_LOGIN_ERROR",
  AUTH_LOGIN_PENDING: "AUTH_LOGIN_PENDING",
  AUTH_LOGOUT_SUCCESS: "AUTH_LOGOUT_SUCCESS",
  AUTH_LOGOUT_ERROR: "AUTH_LOGOUT_ERROR",
  AUTH_LOGOUT_PENDING: "AUTH_LOGOUT_PENDING",
  AUTH_AUTHORISE_SUCCESS: "AUTH_AUTHORISE_SUCCESS",
  AUTH_AUTHORISE_ERROR: "AUTH_AUTHORISE_ERROR",
  AUTH_AUTHORISE_PENDING: "AUTH_AUTHORISE_PENDING",
}
